import { useState, useEffect, useRef } from 'react';

const useExternalBanner = () => {
  const bannerRef = useRef(null);
  const [bannerHeight, setBannerHeight] = useState(0);
  const [isDisplayed, toggleDisplay] = useState(false);

  const mutationCallback = mutations => {
    const newDisplay = mutations[0].target.style.display;
    if (newDisplay !== isDisplayed) {
      setBannerHeight(newDisplay === 'none' ? 0 : mutations[0].target.offsetHeight);
    }
  };

  useEffect(() => {
    let timer = 0;
    const interval = setInterval(() => {
      if (timer < 30 || !bannerRef.current) {
        bannerRef.current =
          document.body.querySelector('#st_banner') ||
          document.body.querySelector('.st_banner-campaign');

        if (bannerRef.current) {
          const observer = new MutationObserver(mutationCallback);
          observer.observe(bannerRef.current, {
            attributes: true,
            attributeFilter: ['style'],
          });
          const banner = bannerRef.current;
          toggleDisplay(banner.style.display !== 'none' || banner.style.display !== null);

          if (banner) {
            setBannerHeight(banner ? banner.offsetHeight : 0);
          } else {
            setBannerHeight(0);
          }
        }
      } else {
        clearInterval(interval);
      }

      timer += 1;
    }, 300);

    return () => clearInterval(interval);
  });

  return { bannerRef, bannerHeight };
};

export default useExternalBanner;
